import { keepAskForReload } from "../screens/threads/panel.ts";

const KEY = "adea.staleReload";
/** A second failure this soon after a reload is not a new deploy (the network, the server): no loop of reloads. */
const AGAIN_MS = 60_000;

/**
 * A tab opened before a deploy asks for a piece of the app (the ask panel, a sheet) by its old file name, which the new
 * build no longer has, so the click does nothing. The tab loads the new build instead, once, and a question that was
 * on its way to the ask panel is asked after the reload.
 */
export function reloadOnStaleBuild(): void {
  window.addEventListener("vite:preloadError", () => {
    let last = 0;
    try {
      last = Number(sessionStorage.getItem(KEY) ?? 0);
      if (Date.now() - last < AGAIN_MS) return;
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch {
      // private window: reload anyway; the guard above is what we lose
    }
    keepAskForReload();
    window.location.reload();
  });
}
